import React, { useEffect } from 'react';
import './App.scss';
import Flower from './components/Flower/flower';
import Welcome from './components/Welcome/welcome';
import { Route, Routes } from "react-router-dom";

function App() {
 

  return (
    <>
    <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/flower" element={<Flower />} />
      </Routes>
    </>
 
  );
}

export default App;
